import { IApplicationState } from '../../types/redux';

export const selectCurrentStep = (state: IApplicationState) => state.legalCheck.currentStep;
